// src/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { Button } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      onLogin(userCredential.user);
      navigate("/newSchool");
    } catch (err) {
      setError("로그인 실패!");
    }
  };

  if (currentUser) {
    // 잠깐 표시하고 바로 이동하는 대신, 메시지 남기고 싶다면 이렇게도 가능
    return (
      <div className="text-center mt-5">
        <h2>이미 로그인되어 있습니다.</h2>
        <p>로그아웃 후 다시 시도하세요.</p>
        <Button variant="secondary" onClick={() => auth.signOut()}>
          로그아웃
        </Button>
      </div>
    );
  }

  return (
    <section className="position-relative overflow-hidden pt-5 pt-lg-3">
      <div style={{ textAlign: "center" }}>
        <h1 className="text-center">학교 관리자 로그인</h1>

        <div className="tab-content" id="course-pills-tabContent">
          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", width: "300px" }}
          >
            {error && <p style={{ color: "red" }}>{error}</p>}


            {/* 이메일 */}
            <div className="mb-4">
              <label htmlFor="email" className="form-label">이메일 계정 *</label>
              <div className="input-group input-group-lg">
                <span className="input-group-text bg-light border-0 text-secondary px-3">
                  <i className="bi bi-envelope-fill"></i>
                </span>
                <input
                  id="email"
                  type="email"
                  autoComplete="off"
                  className="form-control border-0 bg-light rounded-end ps-1"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>


            {/* 비밀번호 */}
            <div className="mb-4">
              <label htmlFor="password" className="form-label">비밀번호 *</label>
              <div className="input-group input-group-lg">
                <span className="input-group-text bg-light border-0 text-secondary px-3">
                  <i className="fas fa-lock"></i>
                </span>
                <input
                  id="password"
                  type="password"
                  autoComplete="new-password"
                  className="form-control border-0 bg-light rounded-end ps-1"
                  placeholder="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* 로그인 버튼 */}

            <div className="d-grid justify-content-center">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                className="mb-0"
              >
                로그인
              </Button>
            </div>

          </form>
        </div>
      </div>
    </section>
  );
}

export default Login;
